import { useContext, useEffect } from "react";
import { useParams } from "react-router-dom";
import CampaignListComp from "../../components/CampaignListComp";
import { AppContext } from "../../contexts/AppContext";

const CampaignList: React.FC = () => {
  const { findAndSetStore } = useContext(AppContext);
  const { storeId } = useParams<{ storeId: string }>();
  useEffect(() => {
    if (!storeId) return;
    findAndSetStore(storeId);
  }, [storeId]);

  return <CampaignListComp />;
};

export default CampaignList;
